import { render } from "./Discount.vue?vue&type=template&id=1c4cbdcf"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Discount.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c4cbdcf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c4cbdcf', __exports__)) {
    api.reload('1c4cbdcf', __exports__)
  }
  
  module.hot.accept("./Discount.vue?vue&type=template&id=1c4cbdcf", () => {
    api.rerender('1c4cbdcf', render)
  })

}


export default __exports__